import { createContext, useContext, useState } from "react";

const EmailArtworkContext = createContext({});

export const EmailArtworkProvider = ({ children }) => {
  /*   All States
   ********************************************* */
  const [selectedProject, setSelectedProject] = useState(null);

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  const emailArtworkValues = { selectedProject, setSelectedProject };
  return (
    <EmailArtworkContext.Provider value={emailArtworkValues}>
      {children}
    </EmailArtworkContext.Provider>
  );
};

export default function useEmailArtwork() {
  return useContext(EmailArtworkContext);
}
